import { useStore } from 'effector-react'
import { useEffect } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormValues } from './model'
import { $isHasCarWithVin, checkHasCarByVin, requestByVinFx } from './model'

export const useValidateForm = (form: UseFormReturn<FormValues>) => {
  const { t } = useTranslation()

  const { watch, setError, clearErrors, getValues } = form

  const isHasCarWithVin = useStore($isHasCarWithVin)
  const isPendingVin = useStore(requestByVinFx.pending)

  watch((data, { name, type }) => {
    if (type !== 'change') return
    if (name === 'vin') checkHasCarByVin(data.vin ?? '')
  })

  useEffect(() => {
    if (isHasCarWithVin) {
      const vin = getValues('vin')
      setError('vin', {
        message: t('alert.car with vin already exists', { vin }),
      })
    } else {
      clearErrors('vin')
    }
    // eslint-disable-next-line
  }, [isHasCarWithVin])

  return {
    isValidatePending: isPendingVin,
    isValidateError: isHasCarWithVin,
  }
}
